export function interpolate(template: string, params: { [key: string]: string | number }): string {
  for (const [key, value] of Object.entries(params)) {
    template = template.replace(new RegExp(`{{${key}}}`, 'g'), `${value}`);
  }
  return template;
}
